import React from 'react';
import {
  Card,
  CardActionArea,
  CardContent,
  CardActions,
  Typography,
  Box,
  Chip,
  Divider,
  useTheme,
} from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

/**
 * Tarjeta de bandeja (tray). Muestra el nombre y los metadatos de configuración.
 * El conteo de la cola vive en el chat (TrayQueue), no en la vista CRUD.
 */
const TrayCard = ({ tray, onViewDetails }) => {
  const theme = useTheme();
  const formattedDate = tray.created_at
    ? format(parseISO(tray.created_at), "dd MMM yyyy", { locale: es })
    : 'Sin fecha';

  return (
    <Card
      sx={{
        maxWidth: '100%',
        mb: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
        position: 'relative',
        overflow: 'visible',
        border: `1px solid ${theme.palette.grey[200]}`,
        transition: 'transform 0.3s, box-shadow 0.3s',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0 8px 25px 0 rgba(0,0,0,0.1)'
        }
      }}
    >
      <CardActionArea onClick={() => onViewDetails(tray)} sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ pt: 3, px: 3, flexGrow: 1 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <InboxIcon color="primary" fontSize="small" />
            <Typography
              variant="h5"
              component="div"
              sx={{ fontWeight: 600, pr: 4 }}
              noWrap
            >
              {tray.name || 'Sin nombre'}
            </Typography>
          </Box>

          <Box display="flex" gap={1} flexWrap="wrap" mb={1.5}>
            {tray.is_default && <Chip label="Por defecto" size="small" color="primary" />}
            {tray.max_contacts != null && (
              <Chip label={`Máx. ${tray.max_contacts}`} size="small" variant="outlined" />
            )}
            {tray.bot_enabled != null && (
              <Chip
                label={tray.bot_enabled ? 'Bot: ON' : 'Bot: OFF'}
                size="small"
                color={tray.bot_enabled ? 'success' : 'default'}
              />
            )}
          </Box>

          {tray.description && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.6,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
              }}
            >
              {tray.description}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>

      <Divider />

      <CardActions
        sx={{
          justifyContent: 'flex-end',
          px: 3,
          py: 1.5,
          backgroundColor: theme.palette.grey[50]
        }}
      >
        <Typography
          variant="body2"
          sx={{ fontSize: '0.75rem', color: theme.palette.text.secondary }}
        >
          Creada {formattedDate}
        </Typography>
      </CardActions>
    </Card>
  );
};

export default TrayCard;
